import { render, staticRenderFns } from "./CohortRanking.vue?vue&type=template&id=67458049&scoped=true&"
import script from "./CohortRanking.vue?vue&type=script&lang=js&"
export * from "./CohortRanking.vue?vue&type=script&lang=js&"
import style0 from "./CohortRanking.vue?vue&type=style&index=0&id=67458049&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67458049",
  null
  
)

export default component.exports